export const IconMoveUpDown: {
  name: 'icon_move_up_down-654c907d6800'
} = {
  name: 'icon_move_up_down-654c907d6800'
}
